import { Dispatch } from '@reduxjs/toolkit';
import { connect } from 'react-redux';
import { NavigateFunction } from 'react-router-dom';

import CanvasForm from 'src/pages/Settings/Canvas/Form';
import { StateType } from 'src/redux/reducers';
import { actions as canvasActions } from 'src/redux/reducers/canvas';

const mapStateToProps = (state: StateType) => ({
  submitting: state.canvas.detail.submitting,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createCanvas: (name: string, navigate?: NavigateFunction) =>
    dispatch(canvasActions.requestCreateCanvas({ data: { name }, navigate })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CanvasForm);
